// @flow
import type {HttpService} from 'modules/common/services/http';
import type {TResponse} from 'types';

/**
 * Сервис для загрузки информации о лицензиях
 */
export class CentrifugeApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }

    /**
     * Fetch запрос "Получить данные о канале центрифуги"
     * @return список всех лицензий
     */
    async getConnectionData<T>(): TResponse<T> {
        return this._http.get<T>('/centrifugo/init', {
            extraOptions: {
                isPrivate: true,
            },
        });
    }
}
